function SuccessPage({ info }: { info: any }) {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const dateSelected = info.selectedDate
    ? `${days[new Date(info.selectedDate).getDay()]}, ${months[new Date(info.selectedDate).getMonth()]} ${new Date(info.selectedDate).getDate()}`
    : '';
  const timeSelected = info.selectedDate ? `${info.selectedTime}` : '';

  return (
    <div className="tw-w-4/5 tw-mx-auto tw-mt-24">
      <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full">
        <h3 className="tw-text-center tw-m-0 tw-font-[400] tw-text-4xl">You&apos;re Booked, {info.formName}!</h3>
        <p className="tw-text-center tw-mt-2 tw-font-[400] tw-max-w-[420px]">
          Thanks for scheduling an appointment at Brilliant Earth. We are looking forward to your visit!
        </p>
      </div>

      <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-justify-between tw-mt-10 tw-mx-auto tw-gap-y-4">
        <div className="tw-flex tw-flex-col lg:tw-max-w-[200px] tw-justify-center tw-items-center">
          <span className="tw-font-book tw-text-[11px] tw-font-[400]">LOCATION</span>
          <p className="tw-text-base tw-font-[500] tw-text-center">{info.selectedShowroomStore.modalName}</p>
        </div>

        <div className="tw-flex tw-flex-col lg:tw-max-w-[200px] tw-justify-center tw-items-center">
          <span className="tw-font-book tw-text-[11px] tw-font-[400]">SERVICE</span>
          <p className="tw-text-base tw-font-[500] tw-text-center">{info.selectedServiceName}</p>
        </div>

        <div className="tw-flex tw-flex-col lg:tw-max-w-[200px] tw-justify-center tw-items-center">
          <span className="tw-font-book tw-text-[11px] tw-font-[400]">DATE</span>
          <p className="tw-text-base tw-font-[500] tw-text-center">
            {dateSelected}
            {timeSelected && timeSelected !== 'null' ? ` at ${timeSelected.slice(0, 8)} ${timeSelected.slice(-5)}` : ''}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
